module.exports = __webpack_public_path__ + "media/images/people/boy-10-431c376c4a22959cb0b869bd5e9e4b2f.webp";